import React, { PropsWithChildren, PureComponent } from 'react';

import styled from 'styled-components';

import Box from '../../atoms/Box/Box';
import Icon, { icons } from '../../atoms/Icon';
import Text from '../../atoms/Text/Text';

import { Colors } from '@shared/interfaces/themes';
import { breakpoint } from 'theme';

const IconLeft = styled(Icon)`
  display: none;

  ${breakpoint.m`
    display: inline-block;
  `}
`;

const BoxFlex = styled(Box)`
  display: flex;
  align-items: center;
`;

type AccountControlProps = {
  className?: string;
  onClick?: () => void;
  iconNameLeft?: keyof typeof icons;
  iconNameRight?: keyof typeof icons;
  iconColor?: string;
  color?: keyof Colors;
};

class AccountControl extends PureComponent<
  PropsWithChildren<AccountControlProps>
> {
  static defaultProps = {
    iconNameRight: 'arrow2',
    iconColor: 'cornflowerBlue',
    color: 'cornflowerBlue',
  };

  render() {
    const {
      className,
      children,
      onClick,
      iconNameRight,
      iconNameLeft,
      iconColor,
      color,
    } = this.props;

    return (
      <Box className={className} onClick={onClick}>
        <BoxFlex>
          {iconNameLeft && (
            <IconLeft name={iconNameLeft} width={1.75} height={2} mr={1.5} />
          )}
          <Text
            className="text"
            smSize={1.125}
            size={1.375}
            color={color}
            lineHeight="normal"
            weight={600}
          >
            {children}
          </Text>
        </BoxFlex>
        <Icon name={iconNameRight} color={iconColor} size={1} />
      </Box>
    );
  }
}

const styledAccountControl = styled(AccountControl)`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 0.75em 1em 0.875em;
  border-top: 1px solid ${props => props.theme.colors.blackHaze};

  ${breakpoint.m`
    padding: 1.125em 1.875em 1.25em;
  `}

  a {
    color: inherit;
  }
`;

export default styledAccountControl;
